import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { updateRecentSearches } from "../../../helpers/data_management";
import { sendTrackingEvent } from "../../../helpers/tracking_management";
import { getTrendingJob } from "../../../redux/actions/job_action";
import { store } from "../../../redux/stores/store";
import {
  CategoryBox,
  CategoryIconGrid,
  TrendingSearchesContainer,
  TrendingSearchesOuterWrapper,
  TrendingSearchTitle,
} from "./styles";

function HomepageTrendingSearches(props) {
  const dispatch = useDispatch();
  const router = useRouter();
  const { t } = useTranslation();
  const [width, setWidth] = useState(0);
  const [trendingJobs, setTrendingJobs] = useState({});

  useEffect(() => {
    fetchData();

    // Compare once and add resize listener on "componentDidMount"
    window.addEventListener("resize", compareSize);

    if (!width) {
      setWidth(window.innerWidth);
    }

    // Remove resize listener again on "componentWillUnmount"
    return () => {
      window.removeEventListener("resize", compareSize);
    };
  }, []);

  const compareSize = () => {
    setWidth(window.innerWidth);
  };

  function handleChipClicked(event, keyword, count) {
    sendTrackingEvent({
      event: "CE_trending_keywords_click",
      keyword: keyword,
      rank: count + 1,
    });

    event.stopPropagation();
    event.preventDefault();

    // Normalize the keyword into a slug (lowercase, replace spaces & symbols with hyphens)
    const slug = keyword.toLowerCase().trim();

    store.getState().jobs.jobListFilterLanding["keyword"] = keyword;
    updateRecentSearches(keyword);
    store.getState().jobs.fromLandingPage = true;
    store.getState().jobs.fromHomepageTrendingSearches = true;

    // Redirect dynamically
    router.push(`${slug}`);
  }

  async function fetchData() {
    try {
      const data = await dispatch(getTrendingJob());
      setTrendingJobs(data);
    } catch (error) {
      console.error("Error fetching trending jobs:", error);
    }
  }
  return (
    <TrendingSearchesOuterWrapper>
      <TrendingSearchesContainer>
        <TrendingSearchTitle>{trendingJobs?.title}</TrendingSearchTitle>
        {trendingJobs?.trendingJob?.map((keyword, index) => {
          return (
            <CategoryBox
              display="grid"
              gridTemplateColumns="repeat(2, auto)"
              key={keyword?.keyword || index}
              onClick={(event) =>
                handleChipClicked(event, keyword?.keyword, index)
              }
              id={index}
            >
              <CategoryIconGrid
                container
                justifyContent="center"
                alignItems="center"
              >
                {keyword?.icon?.data?.attributes?.url && (
                  <img
                    src={keyword.icon.data.attributes.url}
                    alt={keyword}
                    loading="lazy"
                  />
                )}
              </CategoryIconGrid>
            </CategoryBox>
          );
        })}
      </TrendingSearchesContainer>
    </TrendingSearchesOuterWrapper>
  );
}

const mapStateToProps = (state) => {
  return {
    jobListFilterLanding: state.jobs.jobListFilterLanding,
    trendingJobKeywords: state.jobs.trendingJobKeywords,
  };
};

export default connect(mapStateToProps, null)(HomepageTrendingSearches);
